import React from "react";
import {
  Navbar,
  NavbarBrand,
  Button,
  Container
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../Assets/images/logo.png";
import "../Assets/css/style.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ check admin login
  const adminToken = localStorage.getItem("admin_token");

  // ✅ logout handler
  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin-login");
  };

  // ✅ show logout only in admin pages
  const isAdminPage =
    location.pathname.startsWith("/admin-") &&
    location.pathname !== "/admin-login";
  return (
    <Navbar className="app-navbar" dark>
      <Container fluid className="d-flex justify-content-between align-items-center">

        {/* Logo */}
        <NavbarBrand
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={logo} alt="Logo" className="app-logo" />
        </NavbarBrand>

        {/* ✅ Logout button (admin only) */}
        {adminToken && isAdminPage && (
          <Button className="logout-btn" onClick={handleLogout}>
            Logout
          </Button>
        )}

      </Container>
    </Navbar>
  );
};

export default Header;